import React from "react";

const perks = [
  {
    img: "assets/perks/5.png",
    text: "Self & Family Insurance",
  },
  {
    img: "assets/perks/2.png",
    text: "Event Celebration",
  },
  {
    img: "assets/perks/3.png",
    text: "Healthy Culture",
  },
  {
    img: "assets/perks/6.png",
    text: "Annual Increments",
  },
  {
    img: "assets/perks/4.png",
    text: "Paid Leave Encashment",
  },
  {
    img: "assets/perks/1.png",
    text: "Provident Fund",
  },
];

export default function Section4() {
  return (
    <section className="container-1280 perk-and-benefits py-6 md:py-12 bg-white">
      <div className="container-full mx-auto px-4">
        <h2 className="text-3xl font-bold text-center mb-10 text-[#da2128]">Perks and Benefits</h2>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-3">
          {perks.map((perk, index) => (
            <div key={index} className="flex items-center space-x-4">
              <img src={perk.img} alt={perk.text} className="w-10 h-10" />
              <span className="text-[14px] font-bold text-[#da2128]">{perk.text}</span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};
